module.exports = __webpack_public_path__ + "img/facetime_with_friends.ff2e1d5a.jpg";